import request from '@/router/axios';
import crypto from "@/util/crypto.js";

const decryptTransform = (data) => {
  try {
    return crypto.decrypt(data);
  } catch (error) {
    return data;
  }
};

const encryption = (data) => {
  const text = JSON.stringify(data);
  const key = crypto.encrypt(text);
  const formData = new FormData();
  formData.append('data', key);
  return formData;
};

// 获取咨询项目
export const getAppointItemList = () => {
    return request({
      url: "/api/ygj-appoint/v1.0/appoint/item-type/select-list",
      method: "get",
    });
  };
  

  // 患者搜索分页列表
export const getPatientSearchListPage = (params) => {
    return request({
      url: "/api/ygj-pdsop/v1.0/patient-search/list-page",
      method: "post",
      data: params
    });
};


//患者来源树形结构(系统级，患者运营模块用)
export const getSourceTree = (params) => {
  return request({
    url: "/api/ygj-chain/v1.0/source/tree",
    method: "GET",
    params
  });
};


// 获取预约项目分组列表
export const getAppointItemGroupList = (params) => {
    return request({
        url: '/api/ygj-appoint/v1.0/appoint/item/select-list-group',
        method: 'get',
        params: params
    });
};

// 批量创建跟进计划
export const batchSubmitFollowPlan = (params) => {
    return request({
        url: "/api/ygj-patient/v1.0/follow-plan/batch-submit",
        method: "post",
        data: params
    });
};

// 批量创建企微好友跟进计划
export const batchSubmitFollowPlanForWecom = (params) => {
  return request({
    url: "/api/ygj-patient/v1.0/follow-plan/batch-submit-for-wecom",
    method: "post",
    data: params
  });
};


// 获取连锁所有的标签
export const getPatientLabelByChain = (params) => {
  return request({
      url: `/api/ygj-patient/v1.0/label-setting/group-list-chain`,
      method: 'GET',
      params
  })
}

// 获取所有门店常用标签
export const getPatientLabelByClinicCollect = (params) => {
  return request({
      url: `/api/ygj-patient/v1.0/label-setting/group-list-clinic`,
      method: 'GET',
      params
  })
}


// 患者详情极少(顶部)
export const getMiniDetail = (id) => {
  return request({
    url: "/api/ygj-patient/v1.0/patient/detail/" + id,
    method: "GET",
  });
};

//下拉选择患者（v2.0 加密）
export const hightSelectPatient = (params) => {
  const formData = encryption(params);
  return request({
    url: "/api/ygj-high-search/v2.0/hs-patient/select-list-page",
    method: "post",
    data: formData,
    transformResponse: [decryptTransform],
  });
};

//查询当前登录员工与企微客户是否有好友关系
export const getPatientIsFriendApi = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/external-contact/get-is-friend",
    method: "GET",
    params
  });
};



// 卡券管理-活动包列表
export const getActPackList = (params) => {
  return request({
    url: "/api/ygj-marketing/v1.0/coupon/list-page-package",
    method: "GET",
    params,
  });
};

//卡券分类列表
export const getCouponSelectApi = () => {
  return request({
    url: "/api/ygj-marketing/v1.0/coupon-category/select-tree",
    method: "GET",
  });
};

//会员卡分页查询
export const getMemberCardListApi = (params) => {
  return request({
    url: "/api/ygj-marketing/v1.0/member-card/page",
    method: "GET",
    params,
  });
};

/****
 * SOP中的获取卡券列表
*/
export const getCouponListPageSop = (params) => {
  return request({
    url: "/api/ygj-marketing/v1.0/coupon/page-all",
    method: "get",
    params: params,
  });
};


/**
 * 券名模糊查询
 */
export const getQuerySearchName = (data, isAction) => {
  //卡券类型(0-现金券，1-折扣券，2-项目券，3-自选包，4-活动包)
  //isAction 1-活动券 默认0（非活动券）
  return request({
    url: "/api/ygj-marketing/v1.0/coupon/name-like-chain",
    method: "get",
    params: {
      ...data,
      isAction: isAction ? 1 : 0,
    },
  });
};


//管理工作台-今日患者-明日复诊-建跟进（诊后回访-诊前沟通）
export const submitBatchWorkbenchReturnVisit = (data) => {
  return request({
    url: "/api/ygj-chain/v2.0/return-visit/workbench/submit-batch",
    method: "post",
    data,
  });
};










